import { useState } from "react";
import { Link } from "wouter";
import { colors } from "../constants/constants";

const Screen404 = ({ currentScreen }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      {...{
        style: {
          gridArea: "AppContentContainer",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: 700,
          fontSize: "6rem",
          lineHeight: "1",
          flexDirection: "column",
        },
      }}
    >
      <div
        {...{
          style: {
            width: "80%",
            textAlign: "center",
          },
        }}
      >
        Page does not exist 💔
      </div>
      <div
        {...{
          style: {
            width: "80%",
            textAlign: "center",
            marginTop: "4rem",
          },
        }}
      >
        <div
          {...{
            style: {
              color: hover ? colors.purple3 : colors.purple2,
            },
            onMouseEnter: () => setHover(true),
            onMouseLeave: () => setHover(false),
          }}
        >
          <Link href="/">Home</Link>
        </div>
      </div>
    </div>
  );
};

export { Screen404 };
